// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--1wO6n"};